(function(){
    'use strict'

    angular
    .module('app.bancos')
    .controller('EditarBanco', EditarBanco);

    EditarBanco.$inject = ['$scope', '$animationsSrv', '$routeParams','BancosService', 'logger', '$location'];

    function EditarBanco($scope, $animationsSrv, $routeParams, BancosService, logger, $location) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        vm.centrosCosto = [];

        vm.bancoId = $routeParams.id ? $routeParams.id : 0;

        getBanco();

        function getBanco(){

            if(vm.bancoId != 0){
                var promise = BancosService.getById(vm.bancoId);

                promise
                .then(function(banco){
                    vm.banco = banco;
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sesión ha expirado');
                            break;
                    
                        default:
                            logger.error('Hubo un error al obtener el banco: ' + error.data.Message);
                            break;
                    }
                });               
            }

        };

        vm.save = function(){

            $scope.submitted = true;

            if($scope.bancoForm.$valid){
                if(!vm.banco.id){
                    saveBanco();
                }
                else if($scope.bancoForm.$dirty){
                    updateBanco();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function saveBanco() {
            var promise = BancosService.save(vm.banco);
            
            promise
            .then(function(response){
                logger.success('Banco creado con éxito.');
                clearBancoData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el banco: ' + error.data.Message);
                        break;
                }
            });   
        };

        function updateBanco(){
            var promise = BancosService.update(vm.banco);
            
            promise
            .then(function(response){
                logger.success('Banco modificado con éxito.');
                $location.path('/bancos');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el banco: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearBancoData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.banco = {};
            // Set back to pristine.
            $scope.bancoForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.bancoForm.$setUntouched();
        };

    }
})();